import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h3>Ads247.Live</h3>
      <div className="footer-link">
        <a href="/privacy-policy">Privacy policy</a>
        <p className="divider">|</p>
        <a href="/disclaimer">Disclaimer</a>
        <p className="divider">|</p>
        <a href="/data-deletion">Data Deletion</a>
      </div>

      <p style={{ color: "white", marginTop: 4 }}>
        CONTACT: 14 RESIDENCE LA GRANDE PRAIRIE 53 RUE FRANCOIS BOUCHER
        YERRES 91330, FRANCE
      </p>
    </div>
  );
};

export default Footer;
